<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{ modalHeader }}</h4>
    </div>
    <div class="modal-body">
        <div class="form-group col-md-6">
            <label for="org_name">Organization Name</label>
            <input id="org_name" class="form-control" [(ngModel)]="data.Description" >
        </div>
        <div class="form-group col-md-4">
            <label for="org_code">Org Code</label>
            <input id="org_code" class="form-control" [(ngModel)]="data.LoginCode">
        </div>
    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>
    </div>
</ng-template>

<button class="btn btn-primary" *ngIf="openModalButtonVisible" (click)="openForNew()">+ ADD ORGANIZATION</button>